<div class="page-header topfixeds" *ngrxLet="sharedService.startTourObs$ as isTourOn">
  <div
    class="container-fluid"
    *ngrxLet="{
      orgList: (UserDetailsFacade.organizationList$ | async),
      selectedOrg: (UserDetailsFacade.selectedOrg$ | async)
    } as org"
  >
    <div
      class="page-header-top"
      [ngStyle]="{
        'pointer-events': (isTourOn?.length ? isTourOn[0] : isTourOn) ? 'none' : 'auto'
      }"
    >
      <div class="col-lg-12 text-alignment">
        <div class="welcome-text" *ngIf="!showUpdateNotification">
          <span class="page-text">Welcome to PIQET 5. </span>
          <a id="resendMail" class="page-header-text" (click)="openTour()">Click here</a>
          <span class="page-header-text"> for a guided tour of your new tool.</span>
        </div>
        <div *ngIf="showUpdateNotification" class="welcome-text">
          <span class="page-text">Performance updates required. </span>
          <a id="updateApp" class="page-header-text" (click)="applyUpdate()">Click here</a>
          <span class="page-header-text"> to update now for the best experience.</span>
        </div>
      </div>

      <div class="headermenus col-lg-4 text-end">
        <span class="page-header-textMenu" style="text-decoration: none">
          <a class="org-name">{{ org.selectedOrg }}</a>
        </span>
        <span class="page-header-textMenu">
          <a class="sub-menus linked" (click)="openSelectOrganizationModel(org?.orgList)"
            >Change organization</a
          >
        </span>
        <span class="page-header-textMenu">
          <a class="sub-menus linked" (click)="logout()">Sign out</a></span
        >
      </div>
    </div>
  </div>
</div>
